import classNames from "classnames";
import { ReactNode } from "react";

export interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  icon?: string | ReactNode;
  trend?: {
    value: string | number;
    direction: "up" | "down" | "neutral";
  };
  actions?: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const StatCard = ({
  label,
  value,
  icon,
  trend,
  actions,
  className,
  onClick,
}: StatCardProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        "rounded-xl border border-primary-100 bg-white dark:border-primary-800/60 dark:bg-content-900/40 shadow-sm overflow-hidden flex flex-col font-sans",
        onClick && "cursor-pointer hover:border-primary-300 dark:hover:border-primary-600 transition-colors",
        className
      )}
    >
      <div className="flex items-center p-5 gap-4">
        {icon && (
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-white shadow-sm dark:bg-primary-600">
            {typeof icon === 'string' ? <div className={classNames(icon, "text-2xl")} /> : icon}
          </div>
        )}
        
        <div className="flex flex-col min-w-0 flex-1">
          <div className="text-sm font-medium text-content-500 dark:text-content-400 truncate">
            {label}
          </div>
          <div className="flex items-baseline gap-3 mt-1">
            <div className="text-2xl md:text-3xl font-bold text-content-900 dark:text-content-100">
              {value}
            </div>
            {trend && (
              <div className={classNames(
                "flex items-center text-sm font-medium",
                trend.direction === "up" ? "text-success-600 dark:text-success-500" : 
                trend.direction === "down" ? "text-error-600 dark:text-error-500" : 
                "text-content-500"
              )}>
                {trend.direction === "up" && <div className="icon-[ph--arrow-up-right] mr-1" />}
                {trend.direction === "down" && <div className="icon-[ph--arrow-down-right] mr-1" />}
                {trend.value}
              </div>
            )}
          </div>
        </div>
      </div>

      {actions && (
        <div className="border-t border-primary-100 dark:border-primary-800/50 bg-primary-50/30 dark:bg-primary-900/10 px-5 py-3 text-sm font-medium">
          {actions}
        </div>
      )}
    </div>
  );
};
